import { render } from "./IconMenu.vue?vue&type=template&id=a3d14e86"
const script = {}

import exportComponent from "/home/harlan/sites/kintell-env/api/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconMenu.vue"]])

export default __exports__